import styled from "styled-components";

import { colors } from "shared/ui/tokens";

export const MOBILE_BREAKPOINT = 600;

export const Grid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
    gap: 24px;
    /* min-width: 0 — иначе сетка распирает колонку контента внутри LayoutWithMenu. */
    min-width: 0;

    @media (max-width: ${MOBILE_BREAKPOINT - 1}px) {
        grid-template-columns: 1fr;
        gap: 16px;
    }
`;

export const Message = styled.div`
    padding: 24px;
    color: ${colors.textSecondary};
`;
